// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__fvqaJ","Footerlink":"Footer_Footerlink__ScDT1"};